import { createI18n } from 'vue-i18n'
import zh from './locales/zh.json'
import en from './locales/en.json'

// 获取浏览器语言
const getBrowserLanguage = () => {
  const lang = navigator.language || navigator.userLanguage
  return lang.toLowerCase().startsWith('zh') ? 'zh' : 'en'
}

// 获取保存的语言设置或根据浏览器自动检测
const getLocale = () => {
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale) {
    return savedLocale
  }
  return getBrowserLanguage()
}

const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  fallbackLocale: 'en',
  messages: {
    zh,
    en
  }
})

export default i18n
